import React from 'react'
import { Navbar } from 'reactstrap';
import { NavbarBrand } from 'reactstrap';

function Index() {
    return (
        <div>
            <Navbar
                color="dark"
                expand="xl"
                dark
                className="navbar-brand h-100"
                style={{"minHeight": "80px"}}
            >
                <div className="d-flex justify-content-center align-items-center" style={{"width":"100%"}}>
                    <NavbarBrand href="/" >
                        Metal Cutting Fluids Catalog
                    </NavbarBrand>
                </div>
            </Navbar>
        </div>
    )
}
export default Index;